function fixCartDeliveryWording( cartObject ) {
  	if( typeof(window.Shopify.country) !== 'undefined' && 'US' !== window.Shopify.country ) {    
	 const tiersLabel = document.querySelector( '.rewards-tiers-labels-item' ),
	 	rewardsPostUnlock = document.querySelector( '.rewards-post-unlock-text' ),
	 	rewardsPreUnlock = document.querySelector( '.rewards-pre-unlock-text strong' );
	 
	 	if( tiersLabel ) tiersLabel.innerHTML= '<span>Free Delivery</span>';		
	 	if( rewardsPostUnlock ) rewardsPostUnlock.innerHTML = '<p>You get Free Delivery!</p>';
	 	if( rewardsPreUnlock ) rewardsPreUnlock.innerHTML = 'Free Delivery';
	}
}

function doCartUpsells( cartObject ) {// Assuming `data` is your JSON object

    console.log( "Cart JSON", cartObject );

    var addedUpsell = false,
      cartItems = cartObject.items,
      upgradeContainer = document.querySelector('.upgrade-upsells');

    if( upgradeContainer ) upgradeContainer.remove();
  
    cartItems.forEach(item => {
        if ( item.variant_title === "11ml" && addedUpsell === false) {

            // Fetch product information using the product JSON endpoint
            ABfetchProductJson(item.handle, item);

            addedUpsell = true;
        }
    });

  if( !addedUpsell ) {
    setTimeout(function(){
      let upsellsContainer = document.querySelector( '.upsells' );
      console.log( "No upsells were added", upsellsContainer );
      if( upsellsContainer ) upsellsContainer.style.display = 'block';
    }, 1000 );
  }
}

function ABfetchProductJson(productHandle, cartItem) {
    if (productHandle == 'dark-circles-under-eyes') {
      cartSpace = document.querySelector('#slidecarthq .items');
      cartSpace.style.marginBottom = 'auto';
      return
    }
  
    const url = `https://www.amoils.com/products/${productHandle}.json`;

    fetch(url)
        .then(response => response.json())
        .then(productData => {
            // Here you'll have the product data
            console.log ("Product JSON", productData.product );
          
            // Do something with the elemnt
            const upsellElement = ABcreateUpsellElement( productData.product, cartItem );
          
            setTimeout(function(){
                const upsellsContainer = document.querySelector('.upsells'),
                      upsellHeader = document.querySelector('.upsells-header h2'),
                      discountBox = document.querySelector('#slidecarthq .discount-box');
              
                if( upsellsContainer ) {
                  console.log( "Upsell Container Already Exists");
                  
                  if( upsellHeader ) upsellHeader.textContent = 'Upgrade and Save';
                  
                  // Insert the upsellDiv after the itemsDiv
                  if( upsellsContainer.querySelector( '.slick-slider' ) && productData.product.title != "H-Bl Hemorrhoids Formula (for bleeding associated with hemorrhoids)" ) {
                    upsellsContainer.querySelector( '.slick-slider' ).replaceWith( upsellElement );
                  }

                  if ( productData.product.title == "H-Bl Hemorrhoids Formula (for bleeding associated with hemorrhoids)" ) {
                    upsellsContainer.style.display = 'none';
                    discountBox.style.marginTop = "auto";
                  } else {
                    discountBox.style.marginTop = "0px";
                    upsellsContainer.style.display = 'block';
                  }
                  
                } else {
                  console.log( "Upsell Container Does Not Exist");
                  const upsellDiv = document.createElement('div'),
                  itemsDiv = document.querySelector('#slidecarthq .items'),
                  existingUpsellDiv = document.querySelector('.upsells');

                  // Use this code to remove a product from upsell.  Simply add the product name.  Use "||" to add multiple products.
                  if ( productData.product.title == "H-Bl Hemorrhoids Formula (for bleeding associated with hemorrhoids)" ) {
                    //existingUpsellDiv.style.display = 'block';
                    return;
                  }
                  
                  if ( existingUpsellDiv) {
                    existingUpsellDiv.style.display = 'block';
                    return;
                  }
                  
                  upsellDiv.className = 'upsells upgrade-upsells';
                  upsellDiv.innerHTML = `<div class="upsells-header "><h2>Upgrade and Save</h2></div>`;
                  upsellDiv.appendChild( upsellElement );

                  // Insert the upsellDiv after the itemsDiv
                  itemsDiv.insertAdjacentElement('afterend', upsellDiv);
                  
                  upsellDiv.style.display = 'block';
                }

            }, 750 )

        })
}

function ABcreateUpsellElement( productData, cartItem ) {

    // Extract the ID of the first and second variants
    let firstVariantId = productData.variants[0].id,
        secondVariantId = productData.variants[1].id,
        sellingPlanId = cartItem.selling_plan_allocation ? cartItem.selling_plan_allocation.selling_plan.id : false,
        addtoCartObject = sellingPlanId ? { 'id': secondVariantId, 'quantity': 1, 'selling_plan': sellingPlanId } : { 'id': secondVariantId, 'quantity': 1 }, // Add variant ID and quantity here;
        formattedPrice = sellingPlanId ? ( productData.variants[1].price * 0.8 ).toFixed(2) : productData.variants[1].price,
        upsellDiv = document.createElement('div');

    upsellDiv.className = 'upsell multi';
    upsellDiv.setAttribute('data-slidecart-product-id', secondVariantId);
  
    // Add product details
    upsellDiv.innerHTML = `
        <div class="upsell-item">
            <div class="upsell-image">
                <a href="/products/${productData.handle}">
                    <img alt="${productData.title}" class="small" src="${productData.images[0].src}">
                </a>
            </div>
            <div class="upsell-text">
                <h3><a href="/products/${productData.handle}">${productData.title}</a></h3>
                <p class="variants-p">
                    33ml
                    ${ sellingPlanId ? '&middot; <span style="color: inherit; font-weight: 500; font-size: 13px; text-transform: none;">Monthly</span>' : '' }
                    &middot; <span style="color: inherit; font-weight: normal; font-weight: 600; font-size: 13px;">${window.currencySymbol}${ formattedPrice }</span>
                </p>
            </div>
            <div class="upsell-add">
                <button id="add-to-cart-${secondVariantId}">
                    <svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z" fill="currentColor" fill-rule="nonzero"></path></svg>
                    Upgrade
                </button>
            </div>
        </div>`;

    // Add event listener to the button
    const addToCartButton = upsellDiv.querySelector( '#add-to-cart-' + secondVariantId );
    addToCartButton.addEventListener('click', function() {
        // Remove the first variant from the cart
        var removeParams = {
            url: '/cart/change.js',
            data: { 'id': firstVariantId, 'quantity': 0 }, // Set quantity to 0 to remove the item
            dataType: 'json',
            method: 'POST',
            success: function(response) {
                console.log('Item removed from cart:', response);
                
                 var params = {
                  url: '/cart/add.js',
                  data: addtoCartObject, // Add variant ID and quantity here
                  dataType: 'json',
                  method: 'POST',
                  success: function(response) {
                      const upsellsContainer = document.querySelector('.upsells');
                    
                      console.log('Item added to cart:', response);
                      // Handle success (e.g., show a message to the user)
                      
                      // Check if the element exists
                      if (upsellsContainer) {
                          // Hide the element
                          upsellsContainer.style.display = 'none';
                      }
                    
                      window.SLIDECART_UPDATE();
                      window.SLIDECART_OPEN();
    
                  },
                  error: function(response) {
                      console.error('Error adding item to cart:', response);
                      // Handle error
                  }
              };
              $.ajax(params);
            },
            error: function(response) {
                console.error('Error removing item from cart:', response);
                // Handle error for removal
            }
        };
        $.ajax(removeParams);
    });

    return upsellDiv;
}

/**
* Subscription Test
**/
let observerPings = 1;
const observer = new MutationObserver(() => {
  console.log( "Checking for window.showSubscriptionCheckbox", window.showSubscriptionCheckbox );
  if (window.showSubscriptionCheckbox == true ) {
    console.log('Observer ping:', observerPings);
      const widgetTitle = document.querySelector('.appstle_widget_title');
      const subscriptionOption = document.querySelector('.subscription-option');
      console.log('Widget title:', widgetTitle);
      console.log('Subscription option:', subscriptionOption);
      
      if (widgetTitle && !subscriptionOption) {
        console.log('Adding subscription HTML');
        const subscriptionHTML = `
          <div class="subscription-option">
              <h3>GET A MONTHLY SUBSCRIPTION</h3>
              <div class="subscription-content">
                  <label>
                      <span>
                          <input type="checkbox" id="subscribe" data-gtm-form-interact-field-id="0">
                          Subscribe and save!
                      </span>
                      <span class="discount-label"></span>
                  </label>
              </div>
          </div>
        `;
        
        widgetTitle.insertAdjacentHTML('beforebegin', subscriptionHTML);
        
        const subscriptionAmountWrapper = document.querySelector(
          '.appstle_subscription_wrapper_option:nth-child(2) .appstle_subscription_amount_wrapper'
        );
        const discountLabel = document.querySelector('.subscription-content .discount-label');
        
        console.log('Amount wrapper:', subscriptionAmountWrapper);
        console.log('Discount label:', discountLabel);
        
        if (subscriptionAmountWrapper && discountLabel) {
          console.log('Moving subscription amount');
          const clonedWrapper = subscriptionAmountWrapper.cloneNode(true);
          discountLabel.appendChild(clonedWrapper);
          
          console.log('Operation complete, disconnecting observer');
          observer.disconnect();
        }
      }
  
    if (observerPings === 50) {
      console.log('Reached maximum pings, disconnecting observer');
      observer.disconnect();
    }
    
    observerPings++;  
  }
});
console.log('Starting observer');
observer.observe(document.body, {
  childList: true,
  subtree: true
});